import React from 'react'
import { useSelector } from 'react-redux';
import Package from "../../package.json"
import { Link } from 'react-router-dom';

function Footer() {

  const store = useSelector((state) => state.auth.store);
  const link = useSelector((state) => state.auth.link);
  return (
    <footer>
      <div className="container">
        <div className="col-sm-3">

          <h2 className="widgettitle">संपर्क करे</h2>			<div className="textwidget"><ul className="address">
            <li><i className="fa fa-home"></i>{store.store_address}</li>
            <li><i className="fa fa-phone"></i>{store.store_phone}</li>
            <li><i className="fa fa-envelope"></i>{store.store_email}</li>
          </ul>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="contactus">
            <h2 className="widgettitle">क्विक लिंक</h2><div className="menu-footer-menu-container"><ul id="menu-footer-menu" className="menu"><li id="menu-item-1754" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1754"><a href="/">Home</a></li>
              <li id="menu-item-1755" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1755"><a href='https://up.gov.in/en' target='_blank'>Govt. of U.P.</a></li>
              <li id="menu-item-1755" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1755"><a href="https://uphed.gov.in/directorate">H.E.Dept. U.P</a></li>
              <li id="menu-item-1755" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1755"><a href="https://www.ugc.gov.in/">UGC</a></li>
              <li id="menu-item-1755" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1755"><a href="https://www.education.gov.in/en/higher_education">Education Ministry</a></li>
              <li id="menu-item-1755" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1755"><a href="https://shasanadesh.up.gov.in/">U.P. Govt. of G.O.</a></li>
              <li id="menu-item-1757" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1757"><a href="https://ncte.gov.in/Website/Index.aspx">NCTE Jaipur</a></li>
              <li id="menu-item-1757" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1757"><a href="https://dbrau.ac.in/">DBRAU</a></li>

              <li id="menu-item-1757" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1757"><Link to="/contact-us">Contact Us</Link></li>

            </ul></div>
          </div>
        </div>
        <div className="col-sm-4">
          <div className="contactus">
            <h2 className="widgettitle">Useful Links</h2>
            <ul>
              {link.map((lin) =>
                <>
                  <li key={lin.id}>
                    <a href={lin.link} style={{ color: 'white' }} target='_blank'>{lin.name}</a>
                  </li>
                </>)}

              {/* <li>
                <a href='https://bujhansiadm.samarth.edu.in/' style={{ color: "white" }} target='_blank' >University Admissions Portal : Samarth Portal</a>
              </li>

              <li>
                <a href='https://content.acetians.in/uploads/Regarding%20Admission%20Candidate%20Userguide%20-%20Samarth%2012062025140400609A%2012-06-2025%20(1).pdf' style={{ color: "white" }} target='_blank' >Student Admission User Activity Samarth</a>
              </li>

              <li>
                <a href='https://content.acetians.in/uploads/Regarding%20Admission%20Candidate%20Userguide%20-%20Samarth%2012062025140409964B%2012-06-2025%20(1).pdf' style={{ color: "white" }} target='_blank' >Student Admission User Guide Samarth </a>
              </li> */}

            </ul>


          </div>
        </div>
        <div className="col-sm-3">
          <div className="contactus">
            <h2 className="widgettitle">हमारे बारे में</h2>			<div className="textwidget"><p>{store.store_description}</p>
            </div>

          </div>
        </div>

      </div>
      <div>
        <p style={{ color: 'white', paddingBlockStart: '10px', borderTop: '1px solid white', textAlign: 'center' }}>Developed By  <a style={{ color: 'inherit' }} href="https://acetians.com" target="_blank">Acetians Technologies</a><span style={{ fontSize: '8px' }}> v{Package.version}</span>beta </p>

      </div>
    </footer>
  )
}

export default Footer
